import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { CryptoAccount } from '@/types/contacts';

interface Props {
  readonly account: CryptoAccount;
}

export const CryptoAccountTransactionDetailsItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { account } = props;
  const tr = useTranslator();
  const accountDetails: string =
    account.id === 'CALIZA_WALLET' || account.id === 'REVENUE_EARNINGS'
      ? `${account.currency} | ${tr(account.id)}`
      : [account.currency, tr(account.chain)]
          .filter((value: string): boolean => value !== '')
          .join(' | ');

  return (
    <Box>
      <Typography variant="body2" color="text.primary">
        {tr(account.name)}
      </Typography>
      <Typography
        variant="body2"
        color="custom.LightGray"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis">
        {accountDetails}
      </Typography>
    </Box>
  );
};
